import { createApp } from 'vue';
import { store } from "./store";
import 'theme/moydom/less/pages/digital-twin/index.less';
import 'theme/moydom/less/pages/construction-work/construction-work.less';
import 'theme/moydom/less/pages/incident.less';
import RouterView from "./views/page/RouterView.vue";
import router from './router/index';
import 'theme/moydom/less/blocks/search-filter/index.less';
import moment from 'moment';
import sklonyator from '../../vue/Utils/sklonyator';

moment.locale('ru');

const app = createApp({
    components: { RouterView },
    template: '<RouterView />'
});
app.provide('store', store);
app.use(router);
app.use(sklonyator);
app.mount("#app-construction-work");
